import { render, staticRenderFns } from "./flowSchemeDtl.vue?vue&type=template&id=024a7979"
import script from "./flowSchemeDtl.vue?vue&type=script&lang=js"
export * from "./flowSchemeDtl.vue?vue&type=script&lang=js"
import style0 from "./flowSchemeDtl.vue?vue&type=style&index=0&id=024a7979&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024a7979')) {
      api.createRecord('024a7979', component.options)
    } else {
      api.reload('024a7979', component.options)
    }
    module.hot.accept("./flowSchemeDtl.vue?vue&type=template&id=024a7979", function () {
      api.rerender('024a7979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flowschemes/components/flowSchemeDtl.vue"
export default component.exports